import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getDeliveryInstructionManagementModuleName } from './delivery-instruction-management.permissions';

export class DeliveryInstructionsPermissions {
  static GroupName = `${getDeliveryInstructionManagementModuleName()}.DeliveryInstructions`;

  static getPermissions = getGroupPermissionFactory(DeliveryInstructionsPermissions.GroupName);

  static Permissions = {
    Create: DeliveryInstructionsPermissions.getPermissions(PermissionEnum.CREATE),
    Read: DeliveryInstructionsPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: DeliveryInstructionsPermissions.getPermissions(PermissionEnum.READ_ALL),
    Update: DeliveryInstructionsPermissions.getPermissions(PermissionEnum.UPDATE),
  };
}
